import { useLayoutEffect, useRef, type ReactNode } from 'react'
import { ScrollBar } from 'admination-react'
import { KompetenzbilanzierungAbschnitte, KompetenzbilanzierungAktion, useKompetenzbilanzierung } from './Kompetenzbilanzierung'

export function KompetenzbilanzierungNachreichen({
  coachingId,
  onGespeichert,
  onBusyChange,
  renderHeader,
}: {
  coachingId: string
  onGespeichert: () => void
  onBusyChange?: (busy: boolean) => void
  renderHeader: (actions?: ReactNode) => ReactNode
}) {
  const scrollerRef = useRef<HTMLElement>(null)
  const kb = useKompetenzbilanzierung(coachingId)
  useLayoutEffect(() => {
    onBusyChange?.(kb.laeuft)
    return () => onBusyChange?.(false)
  }, [onBusyChange, kb.laeuft])
  const speichern = async () => {
    if (await kb.speichern()) onGespeichert()
  }
  return (
    <>
      {renderHeader(<KompetenzbilanzierungAktion kb={kb} onSave={speichern} />)}
      <main className="form" data-scroll-host ref={scrollerRef} data-testid="kompetenzbilanzierung-nachreichen">
        <KompetenzbilanzierungAbschnitte kb={kb} />
      </main>
      <ScrollBar scrollerRef={scrollerRef} />
    </>
  )
}
